module.exports = __webpack_public_path__ + "img/angel_face.3a1642fc.jpg";